import React from 'react'
import { GrowOnHoverSVG } from './GrowOnHoverSVG'

export const MoteLogo = props => {
  const {
    colors: _colors = {},
    transform: _transform = {},
    showShadow = false,
    isAnimated = false,
    size = 24,
    variant = 'normal',
    ...rest
  } = props

  const colors = { background: '#AC0AE8', foreground: '#ffffff', ..._colors }
  const transform = { duration: 100, scale: 1.2, ..._transform }

  const { Wrapper, wrapperProps } = React.useMemo(() => {
    let wrapperProps = {
      ...rest
    }

    if (isAnimated) {
      wrapperProps = {
        transformDuration: transform.duration,
        transformScale: transform.scale,
        showShadow,
        ...wrapperProps
      }
    }

    return { Wrapper: isAnimated ? GrowOnHoverSVG : 'svg', wrapperProps }
  }, [isAnimated, showShadow, rest, transform])

  return (
    <Wrapper
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox={variant === 'normal' ? '0 0 24 24' : '0 0 100 100'}
      role='presentation'
      aria-hidden={true}
      focusable={false}
      {...wrapperProps}
    >
      {variant === 'normal' && <NormalVariant colors={colors} />}
      {variant === 'gradient' && <GradientVariant colors={colors} />}
    </Wrapper>
  )
}

const NormalVariant = ({ colors }) => {
  return (
    <>
      <g clipPath='url(#clip0_257_4060)'>
        <circle cx='12' cy='12' r='12' fill={colors.background} />
        <path
          d='M19.937 13.3799V9.19869C19.937 9.17106 19.9363 9.14347 19.9349 9.11591C19.9343 9.10303 19.9331 9.09026 19.9322 9.07744C19.9311 9.06312 19.9303 9.04881 19.9289 9.0345C19.9273 9.01808 19.9252 9.00191 19.9231 8.98567C19.9218 8.97508 19.9207 8.96448 19.9191 8.95395C19.9165 8.93629 19.9134 8.91882 19.9103 8.90135C19.9087 8.89218 19.9072 8.88276 19.9054 8.87384C19.9019 8.85605 19.8979 8.8384 19.8939 8.8208C19.8918 8.81194 19.8899 8.80308 19.8877 8.79422C19.8835 8.77712 19.8788 8.76014 19.874 8.74323C19.8713 8.73381 19.8688 8.72464 19.866 8.71491C19.8613 8.69917 19.8562 8.68393 19.851 8.66819C19.8475 8.65747 19.844 8.64681 19.8403 8.63616C19.8353 8.62222 19.83 8.60846 19.8247 8.59464C19.8201 8.58262 19.8154 8.57054 19.8105 8.55865C19.8056 8.54675 19.8003 8.53467 19.795 8.52277C19.7889 8.50933 19.7833 8.49588 19.777 8.48256C19.7722 8.4724 19.7671 8.46236 19.7621 8.45232C19.7549 8.43764 19.7475 8.42302 19.7398 8.40858C19.7352 8.39984 19.7303 8.39135 19.7255 8.38274C19.717 8.36744 19.7084 8.3522 19.6994 8.33708C19.6947 8.32927 19.6897 8.32159 19.6849 8.31384C19.6755 8.29854 19.6659 8.28323 19.6559 8.26818C19.6507 8.26049 19.6453 8.253 19.6401 8.24538C19.6299 8.23075 19.6199 8.21613 19.6093 8.202C19.6031 8.19345 19.5964 8.18521 19.5899 8.17685C19.58 8.16384 19.57 8.15083 19.5596 8.13806C19.5506 8.12697 19.5411 8.11631 19.5318 8.10553C19.5235 8.09574 19.5153 8.08583 19.5066 8.07623C19.4696 8.03533 19.4308 7.99632 19.3903 7.95918C19.3806 7.95045 19.3708 7.94227 19.3611 7.93378C19.3503 7.92442 19.3397 7.91519 19.3288 7.9059C19.3161 7.89536 19.3031 7.88545 19.2901 7.87541C19.2818 7.86922 19.2736 7.86228 19.2655 7.85596C19.2512 7.84524 19.2367 7.83508 19.2224 7.82498C19.2148 7.81971 19.2074 7.81426 19.1997 7.80912C19.1847 7.79902 19.1696 7.78941 19.1543 7.77981C19.1466 7.77498 19.139 7.77002 19.1312 7.76531C19.1162 7.7562 19.101 7.74765 19.0858 7.73904C19.0773 7.73421 19.0688 7.72931 19.0601 7.72467C19.0457 7.71686 19.0312 7.70955 19.0169 7.70224C19.0069 7.69722 18.9969 7.69214 18.9868 7.6873C18.9735 7.68111 18.9602 7.67491 18.9468 7.66909C18.9349 7.66382 18.9232 7.65855 18.9112 7.65354C18.8991 7.64852 18.8873 7.64399 18.8754 7.63935C18.8616 7.63396 18.8479 7.62863 18.834 7.62367C18.8235 7.61989 18.8129 7.61642 18.8023 7.61283C18.7868 7.60762 18.7715 7.60248 18.7558 7.59777C18.7464 7.59492 18.737 7.59238 18.7276 7.58972C18.7107 7.58495 18.6939 7.58024 18.6769 7.57596C18.6681 7.57379 18.6593 7.57187 18.6505 7.56977C18.633 7.56568 18.6154 7.56165 18.5977 7.55818C18.5886 7.55638 18.5792 7.5549 18.5704 7.55322C18.553 7.55012 18.5356 7.54703 18.518 7.54436C18.5075 7.54281 18.4971 7.5417 18.4865 7.54034C18.4704 7.53829 18.4542 7.53606 18.438 7.53451C18.4237 7.53308 18.4095 7.53222 18.3952 7.53123C18.3825 7.5303 18.3698 7.52906 18.357 7.52844C18.3022 7.52571 18.2473 7.52571 18.1924 7.52844C18.1796 7.52906 18.167 7.5303 18.1543 7.53123C18.14 7.53222 18.1257 7.53308 18.1114 7.53451C18.0952 7.53606 18.079 7.53829 18.0629 7.54034C18.0524 7.5417 18.0419 7.54281 18.0313 7.54436C18.0138 7.54697 17.9965 7.55012 17.9791 7.55322C17.97 7.5549 17.9606 7.55638 17.9517 7.55818C17.934 7.56165 17.9165 7.56568 17.899 7.56977C17.8902 7.57181 17.8813 7.57373 17.8725 7.57596C17.8555 7.58024 17.8387 7.58495 17.8219 7.58972C17.8124 7.59238 17.803 7.59492 17.7936 7.59777C17.778 7.60248 17.7628 7.60762 17.7472 7.61283C17.7366 7.61642 17.7259 7.61989 17.7153 7.62367C17.7015 7.62863 17.6878 7.63396 17.6741 7.63928C17.6622 7.64399 17.6502 7.64858 17.6382 7.65354C17.6262 7.65849 17.6145 7.66382 17.6027 7.66909C17.5893 7.67528 17.5759 7.68098 17.5626 7.6873C17.5525 7.69214 17.5426 7.69722 17.5326 7.70224C17.518 7.70955 17.5035 7.71686 17.489 7.72467C17.4804 7.72931 17.472 7.73421 17.4635 7.73898C17.4482 7.74759 17.433 7.7562 17.4179 7.76531C17.4102 7.77002 17.4027 7.77492 17.395 7.77975C17.3797 7.78935 17.3642 7.79896 17.3494 7.80912C17.3418 7.81426 17.3345 7.81965 17.3269 7.82485C17.3123 7.83508 17.2977 7.8453 17.2834 7.85583C17.275 7.86203 17.2669 7.86866 17.2587 7.8751C17.2457 7.8852 17.2327 7.89524 17.2199 7.90608C17.209 7.91507 17.1986 7.92467 17.188 7.93366C17.1774 7.94264 17.1681 7.95057 17.1584 7.95943C17.1385 7.97756 17.119 7.99615 17.1 8.0152L17.0988 8.01631L13.2855 11.8511V4.59935C13.2855 4.26856 13.1879 3.94522 13.0052 3.67019C12.8224 3.39517 12.5627 3.18082 12.2588 3.05424C11.9549 2.92766 11.6205 2.89455 11.2979 2.95908C10.9753 3.02361 10.679 3.18289 10.4464 3.41678L5.45714 8.43423C5.30212 8.58949 5.17919 8.77407 5.09544 8.97733C5.01169 9.18059 4.96878 9.39851 4.96918 9.61853V11.2893L1.71429 14.5626C1.86872 14.7179 2.05206 14.8411 2.25383 14.9251C2.45561 15.0092 2.67187 15.0524 2.89028 15.0524C3.10868 15.0524 3.32494 15.0092 3.52672 14.9251C3.72849 14.8411 3.91183 14.7179 4.06626 14.5626L8.29528 10.3096V17.5612C8.29528 17.892 8.39282 18.2153 8.57556 18.4904C8.7583 18.7654 9.01804 18.9798 9.32193 19.1064C9.62582 19.2329 9.96021 19.2661 10.2828 19.2015C10.6054 19.137 10.9018 18.9777 11.1343 18.7438L14.9477 14.909V18.3973C14.9477 18.8409 15.1229 19.2663 15.4348 19.5799C15.7467 19.8936 16.1697 20.0698 16.6108 20.0698L21.6 15.0523C21.159 15.0523 20.736 14.8761 20.4241 14.5625C20.1122 14.2488 19.937 13.8235 19.937 13.3799Z'
          fill={colors.foreground}
        />
      </g>
      <defs>
        <clipPath id='clip0_257_4060'>
          <rect width='24' height='24' fill={colors.foreground} />
        </clipPath>
      </defs>
    </>
  )
}

const GradientVariant = ({ colors }) => {
  return (
    <>
      <circle
        cx='50'
        cy='50'
        r='49.102'
        fill={colors.background}
        stroke={colors.background}
        strokeWidth='1.796'
      />
      <circle
        cx='50'
        cy='50'
        r='47.5'
        fill='url(#paint0_linear)'
        opacity='0.21'
      />
      <g opacity='0.1'>
        <circle
          cx='50'
          cy='50'
          r='47.5'
          fill='url(#paint1_linear)'
          opacity='0.21'
        />
      </g>
      <path
        fill={colors.foreground}
        d='M78.832 54.848v-14.94c0-.098-.002-.197-.007-.295l-.01-.138c-.004-.05-.007-.102-.013-.153-.006-.059-.014-.117-.021-.175l-.015-.113a5.668 5.668 0 00-.033-.188c-.006-.033-.011-.066-.018-.098a6.198 6.198 0 00-.043-.19l-.022-.095a6.206 6.206 0 00-.051-.182l-.03-.101c-.017-.056-.036-.11-.056-.167-.013-.038-.025-.076-.04-.114-.018-.05-.037-.1-.057-.149-.017-.043-.034-.086-.053-.128a6.55 6.55 0 00-.057-.129l-.067-.143-.055-.108a6.132 6.132 0 00-.083-.157l-.053-.092a6.919 6.919 0 00-.097-.163l-.053-.083a5.814 5.814 0 00-.108-.163l-.059-.082a5.6 5.6 0 00-.114-.155l-.072-.09c-.037-.046-.074-.093-.112-.138-.034-.04-.069-.078-.103-.116l-.094-.105a6.354 6.354 0 00-.431-.418c-.036-.031-.073-.06-.108-.091l-.12-.1a4.91 4.91 0 00-.144-.108l-.091-.07a5.084 5.084 0 00-.16-.11l-.084-.057a6.062 6.062 0 00-.168-.105l-.086-.052-.168-.094-.096-.051c-.053-.028-.107-.054-.16-.08l-.112-.054a6.04 6.04 0 00-.148-.065l-.132-.055-.133-.051a5.743 5.743 0 00-.153-.056l-.118-.039a5.48 5.48 0 00-.172-.053l-.105-.03a6.58 6.58 0 00-.188-.048l-.098-.023a5.71 5.71 0 00-.196-.041l-.101-.018a7.628 7.628 0 00-.194-.031l-.117-.015c-.06-.007-.12-.015-.18-.02-.053-.006-.106-.009-.159-.012-.047-.004-.094-.008-.141-.01a6.342 6.342 0 00-.61 0 3.27 3.27 0 00-.142.01c-.053.003-.106.006-.16.011l-.18.021-.116.015c-.065.009-.13.02-.194.031l-.102.018c-.065.012-.13.027-.195.041l-.098.023a6.634 6.634 0 00-.188.049c-.035.01-.07.018-.105.029-.058.016-.114.035-.172.053l-.118.039-.153.056-.133.05-.132.056-.148.065-.112.054a5.508 5.508 0 00-.161.08c-.032.016-.064.034-.095.051-.057.03-.113.062-.169.094l-.085.052a4.324 4.324 0 00-.17.105l-.082.056a6.552 6.552 0 00-.162.11l-.091.07a2.913 2.913 0 00-.145.11c-.04.032-.078.066-.118.099a6.117 6.117 0 00-.327.291l-.004.004-14.142 13.701v-25.91a5.844 5.844 0 00-1.04-3.32 6.13 6.13 0 00-2.768-2.2 6.354 6.354 0 00-3.563-.34c-1.197.23-2.296.8-3.158 1.635L25.13 37.177a5.947 5.947 0 00-1.341 1.94 5.796 5.796 0 00-.469 2.291v5.97L11.25 59.073a6.184 6.184 0 002.001 1.295 6.34 6.34 0 004.72 0c.749-.3 1.429-.74 2.002-1.295l15.684-15.195v25.909c0 1.182.362 2.337 1.04 3.32a6.13 6.13 0 002.767 2.2 6.352 6.352 0 003.564.34 6.232 6.232 0 003.158-1.635l14.142-13.701v12.463c0 1.585.65 3.105 1.807 4.226a6.27 6.27 0 004.361 1.75L85 60.823a6.27 6.27 0 01-4.361-1.75 5.882 5.882 0 01-1.807-4.225z'
      />
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='97.5'
          x2='2.5'
          y1='2.5'
          y2='97.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ffffff' stopOpacity='0' />
          <stop offset='0.464' stopColor='#ffffff' />
          <stop offset='1' stopColor='#ffffff' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear'
          x1='97.5'
          x2='2.5'
          y1='2.5'
          y2='97.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ffffff' stopOpacity='0' />
          <stop offset='0.464' stopColor='#ffffff' />
          <stop offset='1' stopColor='#ffffff' stopOpacity='0' />
        </linearGradient>
      </defs>
    </>
  )
}
